
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAnimationSimplifier } from "@/hooks/use-animation-simplifier";

interface Card3DProps {
  className?: string;
  children?: React.ReactNode;
  depth?: number;
  disabled?: boolean;
}

export const Card3D = ({ className, children, depth = 5, disabled = false }: Card3DProps) => {
  const isMobile = useIsMobile();
  const { shouldSimplifyAnimations } = useAnimationSimplifier();
  
  const shouldApply3DEffects = !isMobile && !disabled;
  
  return (
    <div className={shouldApply3DEffects ? "perspective-1000" : ""}>
      <motion.div
        className={cn(
          "bg-white/80 backdrop-blur-sm border border-brand-accent/30 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300",
          className
        )}
        whileHover={
          shouldApply3DEffects && !shouldSimplifyAnimations
            ? {
                rotateY: 5,
                rotateX: -5,
                translateZ: depth,
                boxShadow: "0 25px 50px rgba(97, 46, 215, 0.2)",
                transition: { duration: 0.3 }
              }
            : { 
                scale: 1.02,
                boxShadow: "0 20px 40px rgba(97, 46, 215, 0.15)",
                borderColor: "rgba(132, 102, 218, 0.4)",
                transition: { duration: 0.3 }
              }
        }
      >
        {children}
      </motion.div>
    </div>
  );
};
